
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'

import { SeAvatarGroupComponent } from './avatar-group.component'
import { SeCommonAvatarModule } from '../common-avatar/common-avatar.module'
import { SeCountAvatarModule } from '../count-avatar/count-avatar.module'

@NgModule({
  imports: [
	CommonModule, 
    SeCommonAvatarModule,
    SeCountAvatarModule
  ],
  declarations: [
    SeAvatarGroupComponent,
  ],
  exports: [
    SeAvatarGroupComponent
  ]
})
export class SeAvatarGroupModule {}

export const SE_AVATAR_GROUP_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.avatarGroup`

